import { Flex } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { LineChartLegendItemWithCheckbox } from '../../../../../../components/line-chart/line-chart-legend-item-with-checkbox';
import { useMilestonesTabStore } from '../../../../../../store/strategy-store/strategy-store';
import { toggleMilestoneThroughputTypeVisibility } from '../../../../../../store/strategy-store/strategy-store.actions';
import { Text } from '../../../../../../ui-library/typography/typography';
import { getChartLineName, getLegendItems, getMilestoneReferenceLineItems } from './milestone-progress-chart.helpers';

const LineChartLegendItem = ({ label, color }: { label: string; color: string }) => {
  return (
    <Flex align="center" gap="xs">
      <div style={{ width: 12, height: 2, backgroundColor: color, borderRadius: 1 }} />
      <Text size="small" lineHeight="none">
        {label}
      </Text>
    </Flex>
  );
};

export const MilestoneProgressChartLegend = () => {
  const { t } = useTranslation();
  const visibleThroughputTypes = useMilestonesTabStore((state) => state.visibleThroughputTypes);
  const metric = useMilestonesTabStore((state) => state.metric);

  const legendItems = getLegendItems();
  const milestoneReferenceLineItems = getMilestoneReferenceLineItems(t);

  return (
    <Flex justify="center" align="center" gap="md" h="100%">
      {legendItems.map((item) => {
        const itemId = item.dataKey;
        const isChecked = visibleThroughputTypes[item.throughputType];
        const label = getChartLineName(item.dataKey, metric, t);

        return (
          <LineChartLegendItemWithCheckbox
            key={`legend-item-${itemId}`}
            value={itemId}
            label={label}
            color={item.color}
            isChecked={isChecked}
            onToggle={() => toggleMilestoneThroughputTypeVisibility(item.throughputType)}
          />
        );
      })}
      {milestoneReferenceLineItems.map((item) => (
        <LineChartLegendItem key={`milestone-ref-line-${item.label}`} label={item.label} color={item.color} />
      ))}
    </Flex>
  );
};
